import styled from "styled-components"

export default {
    "Wrapper": styled.main`
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 96px 28px;
        gap: 60px;
    `,
    "Title": styled.h1`
        ${({ theme }) => theme.font["heading-bold"]};
    `,

    "Form": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
    `,
    "ShowButton": styled.button`
        display: flex;
        align-items: center;
    `,

    "ButtonDiv": styled.div`
        width: 100%;
    `,

    "movePageButton": styled.button`
        ${({ theme }) => theme.font["small-semibold"]};
    `,
}